import TypeHelper from './TypeHelper';

export default {
    MILEAGE_COMPENSATION: 300000,
    AVG_COMPENSATION_PERCENTAGE_MIN: 0.05,
    AVG_COMPENSATION_PERCENTAGE_MAX: 0.15,
    calculateBigCompensation(caseData)
    {
        let compensation = 0;

        let usingAdvantage = this.calculateUsingAdvantage(caseData);

        compensation = caseData.price - usingAdvantage;

        return compensation;
    },
    calculateAvgCompensationMin(caseData)
    {
        return caseData.price * this.AVG_COMPENSATION_PERCENTAGE_MIN;
    },
    calculateAvgCompensationMax(caseData)
    {
        return caseData.price * this.AVG_COMPENSATION_PERCENTAGE_MAX;
    },
    calculateAvgCompensationMinWithUsingAdvantage(caseData)
    {
        let compensation = 0;

        let usingAdvantage = this.calculateUsingAdvantage(caseData);

        let baseCompensation = this.calculateAvgCompensationMin(caseData);

        let remnantPercentage = 1 - this.AVG_COMPENSATION_PERCENTAGE_MIN;

        let salvageValue = (caseData.price * remnantPercentage) - usingAdvantage;

        compensation = baseCompensation;

        if (salvageValue < 0)
            compensation = compensation - salvageValue * -1;

        return compensation;
    },
    calculateAvgCompensationMaxWithUsingAdvantage(caseData)
    {
        let compensation = 0;

        let usingAdvantage = this.calculateUsingAdvantage(caseData);

        let baseCompensation = this.calculateAvgCompensationMax(caseData);

        let remnantPercentage = 1 - this.AVG_COMPENSATION_PERCENTAGE_MAX;

        let salvageValue = (caseData.price * remnantPercentage) - usingAdvantage;

        compensation = baseCompensation;

        if (salvageValue < 0)
            compensation = compensation - salvageValue * -1;

        return compensation;
    },
    calculateUsingAdvantage(caseData)
    {
        let usingAdvantage = 0;

        let mileagePurchase = caseData.was_new ? 0 : caseData.mileage_purchase;
        let drivenKm = caseData.mileage - mileagePurchase;

        usingAdvantage = caseData.price * drivenKm / (this.MILEAGE_COMPENSATION - mileagePurchase);

        return usingAdvantage;
    },
    isCalculationPossible(caseData)
    {
        return TypeHelper.isNotNullOrUndefined(caseData.was_new)
            && TypeHelper.isNotNullOrUndefined(caseData.mileage)
            && TypeHelper.isNotNullOrUndefined(caseData.price);
    }
}
